import { Box } from '@mui/material';

import { formatDateToClientFormat } from '../../../../../../../constants/helpers/dates';
import { SmsReportDetailsMetadataResponse } from '../interfaces';
import Filter from '../../../../../../common/reports/actions/utils/filter';
import { reportDetailsFilterValuesFormatter } from '../../../../../../../utils/details';

import locales from '../locales';

interface Props {
  filters: SmsReportDetailsMetadataResponse;
}

const FiltersSummary = ({ filters }: Props) => (
  <Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.details.startingDate.label}
          value={formatDateToClientFormat({ date: filters.timeRange.from })}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.details.endDate.label}
          value={formatDateToClientFormat({ date: filters.timeRange.to, type: 'exclusive' })}
        />
      </Box>
    </Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.details.operators.label}
          value={filters.operators.length > 0 ? filters.operators.join(', ') : '< All >'}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.details.statuses.label}
          value={filters.statuses.length > 0 ? filters.statuses.join(', ') : '< All >'}
        />
      </Box>
    </Box>
    <Box>
      <Filter
        label={locales.details.operationIds.label}
        value={filters.operationIds.length > 0 ? filters.operationIds.join(', ') : '< All >'}
      />
    </Box>
    <Box>
      <Filter
        label={locales.details.recipientMsisdns.label}
        value={reportDetailsFilterValuesFormatter(filters.recipientMsisdns)}
      />
    </Box>
  </Box>
);

export default FiltersSummary;
